// ItemTransferModal.js
import { useEffect, useState } from 'react';

import axios from 'axios';


function ItemTransferModal({ productId, sourceCartId, onClose, isOpen }) {
  const [targetCartId, setTargetCartId] = useState('');
  const [activeCarts, setActiveCarts] = useState([]);

  // Fetch active carts on component mount
  useEffect(() => {
    const fetchActiveCarts = async () => {
      try {
        const response = await fetch('http://localhost:5001/api/carts/active-carts');
        const carts = await response.json();
        setActiveCarts(carts);
      } catch (error) {
        console.error('Error fetching active carts:', error);
      }
    };

    fetchActiveCarts();
  }, []);

  const handleConfirmTransfer = async () => {
    try {

        //console.log('sourceCartId', sourceCartId);
    
        if (!sourceCartId || !targetCartId || !productId) {
            alert('Missing required fields for transfer');
            return;
          }

        //console.log('sourceCartId',sourceCartId);
        const response = await axios.post('http://localhost:5001/api/carts/transfer-items', {
            sourceCartId,  // Use the sourceCartId passed as a prop
            targetCartId,
            itemsToTransfer: [productId]
          });

          if (response.status === 200) {
            console.log("Transfer successful:", response.data);
            alert('Items transferred successfully');
             onClose();
          } else {
            console.error("Transfer failed with status:", response.status, response.statusText);
            alert("Error during transfer: " + response.statusText);
          }

     
    } catch (error) {
      console.error('Error during transfer:', error);
      alert('An error occurred while transferring items.');
    }
  };


  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-80">
        <h2 className="text-xl font-bold mb-4">Transfer Item</h2>
        <p>{sourceCartId}</p>
        <label className="block text-sm font-medium mb-2">Select Target Table</label>
        <select
          value={targetCartId}
          onChange={(e) => setTargetCartId(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded mb-4"
        >
          <option value="">Select a table</option>
          {activeCarts.map((cart) => (
            <option key={cart._id} value={cart._id}>
              Table {cart.tableNumber}
            </option>
          ))}
        </select>

        <div className="flex justify-end">
          <button
            className="bg-red-500 text-white px-4 py-2 rounded mr-2"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="bg-teal-500 text-white px-4 py-2 rounded"
            onClick={handleConfirmTransfer}
            disabled={!targetCartId}  // Disable button until a table is selected
          >
            Confirm Transfer
          </button>
        </div>
      </div>
    </div>
  );
}

export default ItemTransferModal;
